import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import styled from 'styled-components';

/* @bend-expect no-styled-foundations-components */
const StyledCloseButton = styled(CloseButton).withConfig({
  displayName: "StyledCloseButton",
  componentId: "v28pzp-0"
})(["top:20px;right:20px;"]);
export default StyledCloseButton;